import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import Alert from '@mui/material/Alert';
import { AlertTitle } from '@mui/material';

import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import AddIcon from '@material-ui/icons/Add';
import AddBoxIcon from '@material-ui/icons/AddBox';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import FolderSharedIcon from '@material-ui/icons/FolderShared';
import FolderOpenIcon from '@material-ui/icons/FolderOpen';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import GroupIcon from '@material-ui/icons/Group';
import DashboardIcon from '@material-ui/icons/Dashboard';


import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MailIcon from '@material-ui/icons/Mail';
import MenuIcon from '@material-ui/icons/Menu';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {Link} from 'react-router-dom'

import {RouterLink} from 'react-router-dom'

import Table from "./DefaultTable"
import DrawerAccount from "./DrawerAccount"
import BrandHeader from "../modules/Whatsapp/components/BrandHeader"
import useAutoHideAlert from "./useAutoHideAlert"

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  title: {
    flexGrow: 1,
  },
  // Страница не прокручивается заново при переходе (после удаления открывается список, а окно
  // осталось внизу), и сообщение в самом верху было вне экрана. Оно прилипает под верхней
  // панелью; фон нужен, чтобы контент под сообщением не просвечивал сквозь рамку.
  alertWrap: {
    position: 'sticky',
    top: 56,
    [theme.breakpoints.up('sm')]: {
      top: 64,
    },
    zIndex: theme.zIndex.appBar - 1,
    backgroundColor: theme.palette.background.default,
  },
}));

function ResponsiveDrawer(props) {
  const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  useAutoHideAlert(props.alert, props.hideAlert);
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100%' }}>
      <BrandHeader />
      <div>
        <props.Monitor/>
      </div>
      <Divider />
      <List>
          <ListItem key="companyList" button component={Link} to='/companylist'>
            <ListItemIcon><FolderSharedIcon/></ListItemIcon>
            <ListItemText primary={'Список Компаний'} />
          </ListItem>
          <ListItem key="companyCreate" button component={Link} to='/createcompany'>
            <ListItemIcon><AddBoxIcon/></ListItemIcon>
            <ListItemText primary={'Создать компанию'} />
          </ListItem>
        <Divider key="divider1" />
        <ListItem key="monitorList" button component={Link} to='/listmonitor'>
            <ListItemIcon><FolderOpenIcon/></ListItemIcon>
            <ListItemText primary={'Мониторинг'} />
          </ListItem>
          <ListItem key="monitorCreate" button component={Link} to='/createmonitor'>
            <ListItemIcon><AddCircleIcon/></ListItemIcon>
            <ListItemText primary={'Создать Новый Склад'} />
          </ListItem>
        <Divider key="divider2" />
        <ListItem key="productTypes" button component={Link} to='/producttypelist'>
            <ListItemIcon><FormatListBulletedIcon/></ListItemIcon>
            <ListItemText primary={'Список культур'} />
          </ListItem>
        <Divider key="divider3" />
        <ListItem key="whatsappStats" button component={Link} to='/whatsappstats'>
            <ListItemIcon><DashboardIcon/></ListItemIcon>
            <ListItemText primary={'Отчёты и аналитика'} />
          </ListItem>
        <ListItem key="whatsappBroadcast" button component={Link} to='/whatsapp'>
            <ListItemIcon><WhatsAppIcon style={{ color: '#25D366' }}/></ListItemIcon>
            <ListItemText primary={'Рассылка WhatsApp'} />
          </ListItem>
          <ListItem key="whatsappLists" button component={Link} to='/whatsapplists'>
            <ListItemIcon><GroupIcon/></ListItemIcon>
            <ListItemText primary={'Списки рассылки'} />
          </ListItem>
          <ListItem key="ProductTypeCreate" button component={Link} to='/createproducttype'>
            <ListItemIcon><AddIcon/></ListItemIcon>
            <ListItemText primary={'Создать культуру'} />
          </ListItem>
      </List>
      <Divider />
      <div style={{ marginTop: 'auto' }}>
        <Divider />
        <DrawerAccount />
      </div>
    </div>
  );
  //console.log(props)
  const container = window !== undefined ? () => window().document.body : undefined;
  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="Открыть меню"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" noWrap className={classes.title}>
            Gradoil
          </Typography>
        </Toolbar>
      </AppBar>
      <nav className={classes.drawer} aria-label="Меню">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <main className={classes.content}>        
        <div className={classes.toolbar} />
        {props.alert.show?<div className={classes.alertWrap}>
          <Alert onClose={props.hideAlert} variant={props.alert.variant} severity={props.alert.severity}>
            <AlertTitle>{props.alert.alertTitle}</AlertTitle>
            {props.alert.alertText}
          </Alert>
        </div>:''}
        <br/>
        {props.tableDescription?<Table tableDescription = {props.tableDescription}/>:''}
        {props.MainContent?<props.MainContent/>:''}
        
      </main>
    </div>
  );
}

ResponsiveDrawer.propTypes = {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default ResponsiveDrawer;